// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBUxef5r04V0pd1LUV_aEGqPiVSLqMJSqQ",
    authDomain: "alexandria-281dc.web.app",
    projectId: "alexandria-281dc",
    storageBucket: "alexandria-281dc.firebasestorage.app",
    messagingSenderId: "647304962472",
    appId: "1:647304962472:web:ea3fa5d209d6f8668abd9d",
    measurementId: "G-F104N98V5B",
    // App Check: reemplazar con tu reCAPTCHA Enterprise site key en producción
    // Firebase Console → App Check → Web → reCAPTCHA Enterprise
    recaptchaSiteKey: '6LePBPssAAAAAH-zkpPr5F0OgLlcWNSt4J2qnaxS',
  },
  posthogKey: '',
  dodo: {
    // TODO: Product IDs from Dodo Payments dashboard → Products
    productIds: {
      latam: {
        monthly:  'REPLACE_WITH_DODO_PRODUCT_ID', // USD $1.90/mo
        annual:   'REPLACE_WITH_DODO_PRODUCT_ID', // USD $19.00/yr
        lifetime: 'pdt_0NgUeOBHtRkVsR9DMwFn0', // USD $15.00 one-time
      },
      world: {
        monthly:  'REPLACE_WITH_DODO_PRODUCT_ID', // USD $4.00/mo
        annual:   'REPLACE_WITH_DODO_PRODUCT_ID', // USD $40.00/yr
        lifetime: 'pdt_0NgUZc3hXWxRAtesrF74M', // USD $29.00 one-time
      },
    },
    checkoutBaseUrl: 'https://test.checkout.dodopayments.com/buy',
    customerPortalUrl: 'https://test.checkout.dodopayments.com/my-orders',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
